var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"progress-group-item",class:{ error: _vm.error }},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"value"},[_vm._t("default")],2),_c('button',{staticClass:"action",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("Change")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }